import React, { useMemo, useState } from "react";
import Pagination from "@mui/material/Pagination";
import BaseTable from "@components/DataTable/BaseTable";
import type { ReviewFalProps } from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/types";
import { useTranslation } from "react-i18next";
import { getFal6PassengerListData } from "../utils";

const ReviewFal6: React.FC<ReviewFalProps> = ({ vesselCallDetails }) => {
  const { t } = useTranslation();
  const { headers, rows, total, translationTitle, testIds } = useMemo(
    () => getFal6PassengerListData({ vesselCallDetails, t }),
    [vesselCallDetails, t],
  );
  const pageSize = 10;
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const pagedRows = useMemo(() => {
    const start = (page - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, page]);

  return (
    <div className="flex flex-col gap-4" data-testid={testIds.wrapper}>
      <h2 className="text-xl">{translationTitle}</h2>
      {total === 0 ? (
        <div className="text-left text-gray-500 font-normal text-sm" data-testid={testIds.empty}>
          {t("vessel-call.no-passengers")}
        </div>
      ) : (
        <>
          <BaseTable rows={pagedRows} headers={headers} />
          {totalPages > 1 && (
            <div className="flex justify-end">
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_, p) => setPage(p)}
                color="primary"
                siblingCount={0}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReviewFal6;
